import { Button, Heading, Stack, Text, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import video1 from '../assests/1.mp4'
import video2 from '../assests/2.mp4'
import video3 from '../assests/3.mp4'
import video4 from '../assests/4.mp4'
import video5 from '../assests/5.mp4'

const Video = () => {
  const videoArr = [video1 , video2 , video3 , video4 , video5]
  const [videoSrc, setVideoSrc] = useState(videoArr[0])
  return <Stack direction={['coloumn','row']} h={'100vh'}>
    <VStack w={'full'}>
  <video controls controlsList='nodownload' src={videoSrc} style={{
    width:'100%'
  }}
  ></video>
  <VStack alignItems={'flex-start'} p='8'w={'full'} overflowY='auto'> 
    <Heading>Sample Video 1</Heading>
    <Text> This is a video for testing and demo</Text>
  </VStack>
  </VStack>
  <VStack w={['full','xl']} alignItems='stretch' p={'8'} spacing='8' overflowY={'auto'}>
  {
    videoArr.map((item,index)=>(
      <Button variant={'ghost'} colorScheme={'purple'} onClick={()=>setVideoSrc(item)}>
      Video {index+1}
    </Button>
    ))
  }
  </VStack>
  </Stack>
}

export default Video